import {MergeMethod, MergeQueueMethod} from '../types'

/**
 * Returns the button text depending on the merge method
 */
export function mergeButtonText({
  mergeMethod,
  confirming,
  isBypassMerge = false,
  inProgress = false,
  isAutoMergeAllowed = false,
  isMergingMultiple = false,
}: {
  mergeMethod: MergeMethod
  confirming: boolean
  isBypassMerge?: boolean
  inProgress?: boolean
  isAutoMergeAllowed?: boolean
  isMergingMultiple?: boolean
}) {
  if (inProgress) {
    const text = isAutoMergeAllowed ? 'Confirming...' : 'Merging...'
    return text
  }
  if (isMergingMultiple) {
    switch (mergeMethod) {
      case MergeMethod.MERGE:
        return confirming ? 'Confirm merge stack' : 'Merge stack'
      case MergeMethod.SQUASH:
        return confirming ? 'Confirm squash and merge stack' : 'Squash and merge stack'
      case MergeMethod.REBASE:
        return confirming ? 'Confirm rebase and merge stack' : 'Rebase and merge stack'
    }
  }

  const autoMergeText = confirming ? 'Confirm auto-merge' : 'Enable auto-merge'
  const bypassText = confirming ? 'Confirm bypass rules and merge' : 'Bypass rules and merge'

  switch (mergeMethod) {
    case MergeMethod.MERGE:
      if (isAutoMergeAllowed) {
        return autoMergeText
      } else if (isBypassMerge) {
        return bypassText
      } else if (confirming) {
        return 'Confirm merge'
      } else {
        return 'Merge pull request'
      }
    case MergeMethod.SQUASH:
      if (isAutoMergeAllowed) {
        return `${autoMergeText} (squash)`
      } else if (isBypassMerge) {
        return `${bypassText} (squash)`
      } else if (confirming) {
        return 'Confirm squash and merge'
      } else {
        return 'Squash and merge'
      }

    case MergeMethod.REBASE:
      if (isAutoMergeAllowed) {
        return `${autoMergeText} (rebase)`
      } else if (isBypassMerge) {
        return `${bypassText} (rebase)`
      } else if (confirming) {
        return 'Confirm rebase and merge'
      } else {
        return 'Rebase and merge'
      }
  }
}

/**
 * Returns the button text depending on the selected merge queue method
 */
export function mergeQueueButtonText({
  mergeMethod,
  confirming,
  inProgress,
  isMergingMultiple = false,
}: {
  mergeMethod: MergeQueueMethod
  confirming: boolean
  inProgress: boolean
  isMergingMultiple?: boolean
}) {
  if (inProgress) {
    return 'Adding to merge queue...'
  }
  if (isMergingMultiple) {
    return confirming ? 'Confirm merge stack' : 'Merge stack'
  }

  switch (mergeMethod) {
    case MergeQueueMethod.GROUP:
      return confirming ? 'Confirm merge when ready' : 'Merge when ready'
    case MergeQueueMethod.SOLO:
      return confirming ? 'Confirm queue and force solo merge' : 'Queue and force solo merge'
  }
}
